// Libs
import React from 'react';
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Document';

const DocumentIcon = ({ onClick, onlyIcon }) => {
	const { theme } = useTheme();

	return onlyIcon ? (
		<Icon fill={theme._highEmphasisColor} onClick={onClick} />
	) : (
		<IconButton onClick={onClick}>
			<Icon fill={theme._highEmphasisColor} />
		</IconButton>
	);
};

export default DocumentIcon;
